module.exports = __webpack_public_path__ + "static/img/menu_icon2.09972f28.png";